import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'SignInModuleContainer'

    static propTypes = {
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      redirectToRoot: PropTypes.func.isRequired,
      signIn: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      email: '',
      password: '',
    }

    componentWillReceiveProps(nextProps) {
      //Redirects to root if user is signed in.
      if (nextProps.user.token) {
        nextProps.redirectToRoot()
      }
    }

    handleInputChange = (e, { name, value }) => {
      this.setState({ [name]: value })
    }

    handleSubmit = e => {
      const { email, password } = this.state
      const { signIn } = this.props

      e.preventDefault()
      signIn(email, password)
    }

    render() {
      return (
        <WrappedComponent
          email={this.state.email}
          hasError={this.props.hasError}
          handleInputChange={this.handleInputChange}
          handleSubmit={this.handleSubmit}
          password={this.state.password}
          isPending={this.props.isPending}
        />
      )
    }
  }

  return Container
}
